module.exports = __webpack_public_path__ + "static/media/zoomIn-dark.7d3975f5.svg";